
import { Component, Prop, Vue } from "vue-property-decorator";
import { GlobalColorGroup } from "@/types/colors";
import { documentStore } from "@/store/store-accessor";
import { saveToWordPressWithErrorsLoggedToUiStore } from "@/lib/wordpress/save";

@Component({})
export default class NodeOnboardingPaletteButton extends Vue {
  @Prop({ required: true }) colorGroup!: GlobalColorGroup;
  @Prop({ required: true }) elementId!: number;

  isUsingDark = true;

  async applyColor() {
    const backgroundColor = this.isUsingDark
      ? this.colorGroup.light.background.cssVariableName
      : this.colorGroup.dark.background.cssVariableName;
    const textColor = this.isUsingDark
      ? this.colorGroup.light.text.cssVariableName
      : this.colorGroup.dark.text.cssVariableName;

    // Update the design properties
    documentStore.unthrottledPropertyChanged({
      elementId: this.elementId,
      path: "design",
      meta: {
        snapshotLabel: `Updated background color`
      },
      value: {
        background: {
          color: `var(--${backgroundColor})`
        },
        text_colors: {
          headings: `var(--${textColor})`,
          text: `var(--${textColor})`,
          brand: `var(--${this.colorGroup.brand.background.cssVariableName})`,
          links: `var(--${this.colorGroup.brand.background.cssVariableName})`
        },
        buttons: {
          primary: {
            background: `var(--${this.colorGroup.brand.background.cssVariableName})`,
            background_hover: `var(--${this.colorGroup.brand.background_hover.cssVariableName})`,
            typography: {
              color: `var(--${this.colorGroup.brand.text.cssVariableName})`
            }
          }
          // secondary: {
          //   outline: "true",
          //   color: `var(--${newVal.colorPalettes.neutral?.scale[300].cssVariableName})`,
          //   typography: {
          //     color: `var(--${newVal.colorPalettes.neutral?.scale[900].cssVariableName})`
          //   }
          // }
        }
      }
    });

    this.isUsingDark = !this.isUsingDark;

    // Save changes to WordPress
    await saveToWordPressWithErrorsLoggedToUiStore();
  }
}
